import { TranslationKey } from 'javascripts/translations/i18n';
import materialsList from './materialsList';
import dailyLog from './dailyLog';
import workOrder from './workOrder';
import estimate from './estimate';
import invoice from './invoice';

export type ExamplePageId = keyof typeof examplePagesKeys;

export const examplePagesKeys = {
  materials_list: 'materials_list',
  daily_log: 'daily_log',
  estimate: 'estimate',
  work_order: 'work_order',
  invoice: 'invoice',
} as const;

export const translations: Record<string, TranslationKey> = {
  [examplePagesKeys.materials_list]: 'pages.examples.materialsList',
  [examplePagesKeys.daily_log]: 'pages.examples.dailyLog',
  [examplePagesKeys.estimate]: 'pages.examples.estimate',
  [examplePagesKeys.work_order]: 'pages.examples.workOrder',
  [examplePagesKeys.invoice]: 'pages.examples.invoice',
};

export const getExamplePagesOrder = ({
  includePagesBetaFeatures,
}: {
  includePagesBetaFeatures: boolean;
}) => [
  ...(includePagesBetaFeatures ? [examplePagesKeys.invoice] : []),
  examplePagesKeys.materials_list,
  examplePagesKeys.daily_log,
  examplePagesKeys.work_order,
  examplePagesKeys.estimate,
];

export const examplePagesIcons = {
  materials_list: 'file-table-outline',
  daily_log: 'file-clock-outline',
  estimate: 'file-chart-outline',
  work_order: 'file-document-check-outline',
  invoice: 'receipt-text-outline',
} as const;

export const exampleNewStatus = {
  materials_list: false,
  daily_log: false,
  estimate: false,
  work_order: false,
  invoice: true,
};

export const getExamplePages = ({
  id,
  includePagesBetaFeatures,
}: {
  id: ExamplePageId;
  includePagesBetaFeatures: boolean;
}) => {
  const pages = {
    [examplePagesKeys.materials_list]: {
      title: 'Materials List',
      body: materialsList,
    },
    [examplePagesKeys.daily_log]: {
      title: 'Daily Log',
      body: dailyLog,
    },
    [examplePagesKeys.work_order]: {
      title: 'Work Order',
      body: workOrder,
    },
    [examplePagesKeys.estimate]: {
      title: 'Estimate',
      body: estimate,
    },
    ...(includePagesBetaFeatures
      ? {
          [examplePagesKeys.invoice]: {
            title: 'Invoice',
            body: invoice,
          },
        }
      : null),
  };

  // If an id is provided, return the specific object or `null` if not found
  if (id) {
    return pages[id] || null;
  }

  return null;
};
